import React from "react"
import ReactDOM from "react-dom/client"
import "./index.css"
import App from "./layout/App"
import reportWebVitals from "./reportWebVitals"
import { store } from "./packages/services/store"
import { Provider } from "react-redux"
import { Buffer } from "buffer"
import * as serviceWorkerRegistration from "./serviceWorkerRegistration"

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement)
window.Buffer = Buffer
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
)
serviceWorkerRegistration.register({})

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
